module.exports = __webpack_public_path__ + "static/assets/b89daa6a9b9f17656d073c965a8adcf0.png";